import { Suspense } from 'react';
import Preloader from '../Shared/Preloader';
import Navbar from '../UI/Navbar';
import HeroSection from './HeroSection';
import About from './About';
import Services from './Services';
import Facts from './Facts';
import Footer from '../Shared/Footer';
import Projects from '../Projects/Projects';
import Testimonial from './Testimonial';
import Contact from './Contact';

const Home = () => {
    return (
        <Suspense fallback={<Preloader />}>
            <div className="home-page">
                <Navbar />
                <HeroSection />
                <About />
                <Services />
                <Facts />
                <Projects />
                <Testimonial />
                <Contact />
                <Footer />
            </div>
        </Suspense>
    );
};

export default Home;
